module.exports = __webpack_public_path__ + "static/media/cardigann.11a25e34.gif";


//////////////////
// WEBPACK FOOTER
// ./src/cardigann.gif
// module id = 814
// module chunks = 0